module.exports = __webpack_public_path__ + "img/ryo.29893fb5.svg";